import React from 'react';
import ReactDOMServer from 'react-dom/server';

import StoreModel from '../models/Index';
import * as rasterizeHTML from 'rasterizehtml';
import FailedTransactioReceipt from '../components/receipts/FailedTransactioReceipt';
import CashCollectionReport from '../components/receipts/CashCollectionReport';

export class ReceiptGenerator {
    static async generateCustomFailedTransactionReceipt(
        accountNumber: string,
        amountInserted: number,
        warningDisclaimer: string,
        store: StoreModel
    ) {
        const receiptContainer =
            '<!DOCTYPE html>' +
            ReactDOMServer.renderToStaticMarkup(
                React.createElement(FailedTransactioReceipt, {
                    receiptAttributes: store.receiptAttributes,
                    accountNumber: accountNumber,
                    cashInserted: amountInserted,
                    storeId: store.locationId,
                    warningDisclaimer: warningDisclaimer,
                })
            );

        return await this.encodedImageFromHtml(receiptContainer, {
            stripFonts: true,
        });
    }

    static async generateCustomFailedCollectionReceipt(
        store: StoreModel,
        closedBatch: string,
        userName?: string
    ) {
        const receiptContainer =
            '<!DOCTYPE html>' +
            ReactDOMServer.renderToStaticMarkup(
                React.createElement(CashCollectionReport, {
                    closedBatch: closedBatch,
                    closedBy: userName,
                    kioskId: store.kioskId,
                    newBatch: store.batchId,
                    receiptAttributes: store.receiptAttributes,
                    cashMetrics: store.collection.userCashMetrics,
                })
            );
        return await this.encodedImageFromHtml(receiptContainer, {
            stripFonts: true,
        });
    }

    static async encodedImageFromHtml(
        html: string,
        options: any
    ): Promise<string> {
        options = options || {};

        var cleanHtml = html;
        cleanHtml = cleanHtml.replace(
            'content="576, target-densitydpi=203"',
            ''
        );

        if (options.stripFonts) {
            cleanHtml = cleanHtml.replace(
                "src: url('file:///android_asset/fonts/free3of9.woff') format('woff'), url('file:///android_asset/fonts/free3of9.ttf') format('truetype');",
                ''
            );
        } else {
            cleanHtml = cleanHtml.replace(/file:\/\/\/android_asset/g, '');
        }

        //The render is done twice. First, we retrieve image dimensions, then we get final rasterized HTML
        var canvas = document.createElement('canvas');
        var rezHtml = await rasterizeHTML.drawHTML(cleanHtml, canvas, {
            baseUrl: window.location.origin,
        });
        canvas.width = options.width || rezHtml.image.width;
        canvas.height = options.height || rezHtml.image.height;

        var ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }

        await rasterizeHTML.drawHTML(cleanHtml, canvas);
        var encodedImage = canvas.toDataURL();
        return encodedImage;
    }
}
